import React, { Fragment, ReactElement, useEffect } from 'react';

import {
  ButtonPattern,
  Container,
  Grid,
  Notification,
  Paragraph,
} from '@constellation/core';
import { useContent } from '@interstellar/react-app-content';
import PageHeading from 'components/pageHeading/PageHeading';
import {
  StyledContainer,
  StyledGridItem,
  StyledOuterContentGroup,
} from 'components/registrationSteps/RegistrationSteps.styled';
import StyledBox from 'components/style/styledBox/StyledBox';
import { Button, Link } from 'components/tagging';

import { AlreadyRegisteredContent } from './AlreadyRegisteredContent';
import { JOURNEY_STEPS, LINK_EVENT } from '../../constants/analytics.constants';
import * as Analytics from '../../utils/analytics';

function AlreadyRegistered(): ReactElement {
  const { alreadyRegisteredContent } = useContent<AlreadyRegisteredContent>();

  useEffect(() => {
    Analytics.setPageLoadEvent(
      JOURNEY_STEPS.ONLINE_REGISTRATION.ALREADY_REGISTERED,
    );
  }, []);
  return (
    <Container padding="none">
      {alreadyRegisteredContent &&
        alreadyRegisteredContent.map(
          ({
            serviceName,
            header,
            notificationHeader,
            forgottenDetails,
            youCan,
            resetThemOnline,
            resetThemOnlineHref,
            btnLabel,
            btnHref,
          }) => (
            <Fragment key="three-steps-to-register-container">
              <PageHeading serviceName={serviceName} header={header} />
              <StyledContainer marginBottom="06">
                <Grid alignY="center">
                  <StyledGridItem>
                    <StyledOuterContentGroup marginBottom="none">
                      <StyledBox>
                        <Notification heading={notificationHeader}>
                          <Paragraph>
                            {forgottenDetails} {youCan}{' '}
                            <Link
                              href={resetThemOnlineHref}
                              event={LINK_EVENT.RESET_THEM_ONLINE}
                              external
                            >
                              {resetThemOnline}
                            </Link>
                          </Paragraph>
                        </Notification>

                        <ButtonPattern marginBottom="none">
                          <Button
                            variation="primary"
                            href={btnHref}
                            taggingLabel={btnLabel}
                          >
                            {btnLabel}
                          </Button>
                        </ButtonPattern>
                      </StyledBox>
                    </StyledOuterContentGroup>
                  </StyledGridItem>
                </Grid>
              </StyledContainer>
            </Fragment>
          ),
        )}
    </Container>
  );
}

export default AlreadyRegistered;
